export default __webpack_public_path__ + "static/media/soumyasudha Ojha.55d0bf43.jpg";